export default __webpack_public_path__ + "static/media/CapaPDFFile.0a3845ee.svg";